import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "@perspective-dev/viewer/dist/css/pro.css";
import "@perspective-dev/workspace/dist/css/pro.css";
import "@/plugins/signal_events_overlay_plugin";

const BUILD_VERSION = import.meta.env.VITE_RTBOT_VERSION ?? "local-dev";

const SUPPRESSED_WARNINGS = [
  "Stage 0 wasm loading failed, skipping",
  "Perspective wasn been initialized in inline mode",
];

const originalWarn = console.warn.bind(console);
console.warn = (...args: unknown[]) => {
  const firstArg = args[0];
  if (typeof firstArg === "string") {
    const shouldSuppress = SUPPRESSED_WARNINGS.some((warning) => firstArg.includes(warning));
    if (shouldSuppress) {
      return;
    }
  }

  originalWarn(...args);
};

console.log(
  `%c[playground] version=${BUILD_VERSION} loaded at ${new Date().toISOString()}`,
  "color: magenta; font-weight: bold"
);

async function bootstrap() {
  const [{ App }, { loadPresetFromUrl }] = await Promise.all([
    import("./App"),
    import("@/lib/preset_loader"),
  ]);

  // Apply URL preset (if any) before first render
  await loadPresetFromUrl();

  ReactDOM.createRoot(document.getElementById("root")!).render(
    <>
      <App />
      <div className="fixed left-2 bottom-2 z-50 text-xs font-thin text-muted-foreground">
        version: {BUILD_VERSION}
      </div>
    </>
  );
}
void bootstrap();
